module.exports = __webpack_public_path__ + "static/media/Summertime Blues (ft Michael Shynes).b372330d.jpg";